import { REDEEM_STATUS } from 'constants/constants';
import { Asset } from 'services/api/dto/Assets';
import { TokenStatusBadgeVariant } from 'components/TokenStatusBadge';

export const getTokenBadgeStatus = (
  rowData: Asset
): [string, TokenStatusBadgeVariant] => {
  console.log('rowData', rowData);
  switch (rowData.redeemStatus) {
    case REDEEM_STATUS.REDEEM_INITIALIZED:
    case REDEEM_STATUS.REDEEM_PAYMENT_UPLOADED:
      return ['Подтверждение оплаты', rowData.isIssuer ? 'yellow' : 'grey'];
    case REDEEM_STATUS.REDEEM_PAYMENT_SIGNED:
    case REDEEM_STATUS.OWNER_PAYMENT_SIGNED:
      return ['Подтверждение погашения', rowData.isIssuer ? 'grey' : 'yellow'];
    case REDEEM_STATUS.COMPLETED:
      return ['Погашен', 'grey'];
    default:
      return ['Активен', 'green'];
  }
};
